'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var resolveThreadedChatAreaContainer = exports.resolveThreadedChatAreaContainer = function resolveThreadedChatAreaContainer() {
  return import( /* webpackChunkName: "threaded-chat-area-container" */'../../threads/containers/ThreadedChatAreaContainer');
};